import { CSSProperties } from 'react';
import { observer } from 'mobx-react-lite';
import { PanelThemeType, PanelType } from './panel-type';
import styles from './panel.module.scss';

export const Panel = observer(
  ({
    classes = [],
    backgroundType,
    backgroundImage,
    backgroundOptions = { grayscale: false, opacity: 100 },
    sizeType,
    overflow,
    children,
    height,
    isTableWrapper,
    productBackground,
  }: {
    classes?: string[];
    children: JSX.Element;
    backgroundImage?: string;
    backgroundOptions?: {
      grayscale?: boolean;
      additionalOptions?: {
        backgroundPosition?: string;
        backgroundAttachment?: string;
        backgroundSize?: string;
      };
      opacity?: number;
      isDefault?: boolean;
      bgContainerCssProps?: CSSProperties;
    };
    backgroundType?: PanelThemeType;
    overflow?: boolean;
    sizeType?: PanelType;
    height?: number;
    isTableWrapper?: boolean;
    productBackground?: boolean;
  }) => {
    const background = {
      '--backgroundImage': `${
        backgroundOptions.grayscale
          ? 'linear-gradient(black, black),'
          : backgroundOptions?.isDefault
          ? 'linear-gradient(90deg, rgba(10,18,29,1) 0%, rgba(10,18,29,1) 5%, rgba(10,18,29,0) 15%, rgba(10,18,29,0) 85%, rgba(10,18,29,1) 95%, rgba(10,18,29,1) 100%),'
          : ''
      } url(${backgroundImage})`,
      '--backgroundBlendMode': backgroundOptions.grayscale ? `saturation` : '',
      '--backgroundPosition': backgroundOptions?.additionalOptions?.backgroundPosition,
      '--backgroundAttachment': backgroundOptions?.additionalOptions?.backgroundAttachment,
      '--backgroundSize': backgroundOptions?.additionalOptions?.backgroundSize,
      '--opacity': (backgroundOptions.opacity ?? 100) / 100,
    };

    const getBackgroundWidth = () => {
      return backgroundOptions?.additionalOptions?.backgroundSize?.includes('%') &&
        !isNaN(+backgroundOptions?.additionalOptions?.backgroundSize?.replace('%', '')) &&
        +backgroundOptions?.additionalOptions?.backgroundSize?.replace('%', '') < 100
        ? 100 - +(backgroundOptions?.additionalOptions?.backgroundSize?.replace('%', '') as any)
        : null;
    };

    const getImageLeftOffset = () => {
      const width = getBackgroundWidth();
      const position = backgroundOptions?.additionalOptions?.backgroundPosition;
      return position?.includes('right') && width ? { left: `${width}%` } : {};
    };

    return (
      <div
        style={{
          ...(backgroundImage ? background : {}),
          ...(height ? { height: `${height}%` } : {}),
        }}
        className={[
          styles.panelContainer,
          backgroundImage ? styles.backgroundProps : '',

          backgroundType === PanelThemeType.Dark
            ? styles.darkPanelBackground
            : backgroundType === PanelThemeType.Light
            ? styles.lightPanelBackground
            : backgroundType === PanelThemeType.Glass
            ? styles.glassCardBackground
            : backgroundType === PanelThemeType.FlatDark
            ? styles.flatDarkPanelBackground
            : styles.transparent,

          sizeType === PanelType.FullWidth ? styles.fullWidth : '',

          isTableWrapper && 'cust-py-sm-4 cust-px-4',

          ...classes,
        ].join(' ')}
      >
        {backgroundImage && productBackground && (
          <div
            className={styles.backgroundContainer}
            style={{
              ...getImageLeftOffset(),
              ...backgroundOptions.bgContainerCssProps,
            }}
          >
            <img
              src={backgroundImage}
              alt="background_image"
              style={{
                width:
                  backgroundOptions?.additionalOptions?.backgroundSize &&
                  (backgroundOptions.additionalOptions.backgroundSize === 'auto' ||
                    backgroundOptions.additionalOptions.backgroundSize === 'cover')
                    ? 'auto'
                    : backgroundOptions?.additionalOptions?.backgroundSize &&
                      backgroundOptions.additionalOptions.backgroundSize.includes('%')
                    ? backgroundOptions.additionalOptions.backgroundSize
                    : '100%',
              }}
            />
            <div className={styles.gradientDivBottom} />
            <div className={styles.gradientDivSide} />
          </div>
        )}
        <div className={`${styles.innerContainer} ${sizeType === PanelType.FullWidth ? '' : ''}`}>{children}</div>
      </div>
    );
  }
);